import authService from './authService';

export default authService;
